import { useAuth } from './useAuth';

export const useNavigationPermissions = () => {
  const { user, isAdmin, userRole, loading } = useAuth();

  // Check for mobile race condition - user is authenticated but userRole not loaded yet
  const effectiveUserRole = userRole || user?.user_metadata?.role;
  const hasMobileRaceCondition = !userRole && user && user.user_metadata?.role;

  // console.log('useNavigationPermissions:', {
  //   loading,
  //   userRole,
  //   metadataRole: user?.user_metadata?.role,
  //   effectiveUserRole,
  //   hasMobileRaceCondition
  // }); // Removed to prevent re-renders causing flicker

  // If we're still loading AND no user metadata available, don't make permission decisions
  if (loading && !user) {
    return {
      canAccessAdminRoutes: false,
      canAccessParentRoutes: false,
      canAccessSuperUserRoutes: false,
      isAdminUser: false,
      userRole: null
    };
  }

  // If no effective role available, deny access
  if (!effectiveUserRole) {
    return {
      canAccessAdminRoutes: false,
      canAccessParentRoutes: false,
      canAccessSuperUserRoutes: false,
      isAdminUser: false,
      userRole: effectiveUserRole
    };
  }

  // Updated logic to explicitly handle bizadmin, owner, and staff roles using effectiveUserRole
  const canAccessAdminRoutes = isAdmin || effectiveUserRole === 'owner' || effectiveUserRole === 'bizadmin' || effectiveUserRole === 'staff';
  const canAccessParentRoutes = effectiveUserRole === 'parent' || isAdmin || effectiveUserRole === 'owner' || effectiveUserRole === 'bizadmin';
  const canAccessSuperUserRoutes = effectiveUserRole === 'superadmin' || (user?.email && [
    'hallryan97@gmail.com',
    'ryan.hall@gtmpact.com',
    'ryan@gtmpact.com'
  ].includes(user.email));


  return {
    canAccessAdminRoutes,
    canAccessParentRoutes,
    canAccessSuperUserRoutes,
    isAdminUser: isAdmin,
    userRole: effectiveUserRole
  };
};
